module.exports = __webpack_public_path__ + "static/img/jjc_today_best.7f49cf72.png";